import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="project--selector"
export default class extends Controller {
  static targets = ["select"]

  // When project dropdown changes, submit the form to load new project
  submitForm(event) {
    const form = event.target.closest('form')
    if (form) {
      form.requestSubmit()
    }
  }

  // Folder selection is a pure UI state change: swap the .active class
  // locally, update the items-signal folder-id (which fires the
  // sidebar-updated event), and POST asynchronously so the session
  // remembers the choice on the next page load.
  selectFolder(event) {
    const newActiveLi = event.target.closest('li.project_folder')
    if (!newActiveLi) return

    const match = newActiveLi.id.match(/project_folder_(\d+)/)
    if (!match) return

    const projectFolderId = match[1]
    if (newActiveLi.classList.contains('active')) return

    // Swap active class within the sidebar
    const sidebar = this.element
    const previouslyActive = sidebar.querySelector('li.project_folder.active')
    if (previouslyActive) previouslyActive.classList.remove('active')
    newActiveLi.classList.add('active')

    // Bump the items-signal folder-id so the project--items controller
    // re-checks which tracks are in this folder. Stimulus emits a
    // value-changed event when the data attribute changes, which the
    // items-signal controller already listens for. The items-signal
    // element lives inside the inner project_specific_content frame.
    const itemsSignalEl = sidebar.querySelector('[data-controller~="project--items-signal"]')
    if (itemsSignalEl) {
      itemsSignalEl.setAttribute('data-project--items-signal-folder-id-value', projectFolderId)
    }

    // Persist server-side; the response body is ignored.
    fetch(`/my/folders/${projectFolderId}/select_simple`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
  }
}
